import { defineStore } from 'pinia';

/**
 * Store to keep information about which modals have been opened.
 */
export const useModalStore = defineStore('modal', {
    state: () => ({
        // Only opened modals are kept in the state.
        // The key is the modal name and the value is a boolean indicating if it's open.
        // This allows for easy checking of whether a modal is open or not.
        // This is a simple implementation, but it can be extended to include more information about each modal if needed.
        modals: {} as Record<string, boolean>,
    }),

    actions: {
        openModal(modalName: string) {
            this.modals = { ...this.modals, [modalName]: true };
        },

        closeModal(modalName: string) {
            if (!this.modals[modalName]) return;
            const newModals = { ...this.modals };
            delete newModals[modalName];
            this.modals = newModals;
        },

        toggleModal(modalName: string) {
            if (this.isModalOpen(modalName)) {
                this.closeModal(modalName);
            } else {
                this.openModal(modalName);
            }
        },

        isModalOpen(modalName: string) {
            return !!this.modals[modalName];
        },
    },

    getters: {
        isAnyModalOpen(state) {
            return Object.values(state.modals).some((isOpen) => isOpen);
        },
        visibleModalCount(state) {
            return Object.values(state.modals).filter((isOpen) => isOpen).length;
        },
    },
});
